import { PartnerProto_EligibilityKeyProto_Value } from "@noom/noom-contracts/noom_contracts/backend/partner/model/partner";

import {
  BgmEligibility,
  EligibilityEnforcementType,
  EligibilitySource,
} from "./Eligibility";

export type EligibilityKeyType = Exclude<
  PartnerProto_EligibilityKeyProto_Value,
  "UNKNOWN" | "UNRECOGNIZED"
>;

export type PartnerEligibilityFileLocation = {
  id: number;
  location: string;
  filenameRegex?: string;
  lastFileIngested?: string;
  lastFileIngestedTimeStamp?: Date;
};

export type Partner = {
  configs: {
    ACCOLADE_PARTNER: boolean;
    BGM_ELIGIBILITY?: BgmEligibility;
    CUSTOM_SUPPORT_LINK?: string;
    DISPLAY_NAME?: string;
    DIVISIONAL_ONLY_PARTNER: boolean;
    ELIGIBILITY_KEY: string;
    ELIGIBILITY_SOURCE?: EligibilitySource;
    ENROLL_PASSCODE: boolean;
    ENROLL_UHC: boolean;
    ENROLL_UPID: boolean;
    ENROLL_VIRGIN_PULSE: boolean;
    HIDE_COST: boolean;
    MAINTAIN_ORIGINAL_LOGO: boolean;
    MEDICARE_PARTNER: boolean;
    OFFERS_DIABETES_MANAGEMENT: boolean;
    /** Enables the CMS ACCESS enrollment experience (e.g. Medicare number collection). */
    OFFERS_CMS_ACCESS?: boolean;
    OFFERS_MED: boolean;
    OFFERS_RETRIAGE: boolean;
    OFFER_SCALE_SHIPMENT: boolean;
    /** When false, skip FDA-labeling / 5% GLP-1 exclusion. Missing means enabled (true). */
    ENFORCE_GLP1_FDA_LABELING_ELIGIBILITY?: boolean;
    /** Partner Med BMI thresholds (PAM-178). Missing means 30 / 27. */
    MED_MIN_BMI?: number;
    MED_MIN_BMI_WITH_COMORBIDITY?: number;
    REQUIRES_DOB: boolean;
    REQUIRES_PARTICIPANT_ID: boolean;
    UPFRONT_ELIGIBILITY_ENFORCEMENT: EligibilityEnforcementType;
  };
  defaultBatch: number;
  deploymentId: number;
  division: string;
  eligibilityKey: EligibilityKeyType;
  enrollPasscode: boolean;
  enrollUPID: boolean;
  enrollVirginPulse: boolean;
  goLiveDate?: Date;
  /** Server-computed enrollment gate (PAM-36). Absent until CoachServer ships the field. */
  enrollmentOpen?: boolean;
  hideCost: boolean;
  id: number;
  name: string;
  requireDob: boolean;
  requireParticipantId: boolean;
  slug: string;
  supportedLocales: string[];
  upfrontEligibilityEnforcement: EligibilityEnforcementType;
  eligibilityFileLocations: PartnerEligibilityFileLocation[];
};

export const getDisplayName = (partner?: Partner | null) =>
  partner?.configs?.DISPLAY_NAME || partner?.name;
